module.exports = __webpack_public_path__ + "img/slys_mobile.489f1f45.png";